module.exports = __webpack_public_path__ + "static/media/project-internetofai.63f42267.png";